import request from '@/utils/request';

export function getAllStories() {
  return request({
    url: '/stories',
    method: 'get'
  });
}

export function getStory(storyId) {
  return request({
    url: `/stories/${storyId}/`,
    method: 'get'
  });
}
